module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-card-text', {
    staticClass: "title",
    staticStyle: {
      "word-break": "break-word",
      "margin-top": "10px"
    },
    attrs: {
      "align": "justify"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouNao()
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.clicouSim()
      }
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-483c06a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-confirm-dialog.vue
// module id = 419
// module chunks = 0